import { graphql, HttpResponse } from 'msw'
import {
  type EnrollmentMultiConfirmInformationData,
  type EnrollmentMultiConfirmInformationSubmitOutput,
} from '../../../../models'
import {
  EnrollmentTaxFilingStatusType,
  PersonalNetWorthRange,
  EnrollmentInvestmentObjectiveCategory,
  EnrollmentInvestmentExperienceCategory,
  MaritalStatus,
} from '../../../../models'

export const getEnrollmentMultiConfirmInformationDataMock: EnrollmentMultiConfirmInformationData = {
  __typename: 'SubmitEnrollmentSuccess',
  path: '/enrollment/multi/confirm-information',
  enrollmentData: {
    firstName: 'George',
    lastName: 'Kanchev',
    phoneNumber: '8044202957',
    email: 'george.kanchev@evergreen.money',
    addressRegionCode: 'MD',
    addressLine1: '7607 Old Georgetown Rd',
    addressLine2: '1809 Apt',
    addressCity: 'Bethesda',
    addressPostalCode: '20814-6442',
    addressCountry: 'US',
    addressRegion: 'MD',
    dateOfBirth: '1990-01-01',
    maskedSsn: '***-**-7890',
    employmentStatus: 'EMPLOYED',
    occupation: 'OTHER',
    isBrokerDealer: false,
    isDirectorPolicyMakerOfCompany: false,
    investmentProfile: {
      maritalStatus: MaritalStatus.SINGLE,
      objective: EnrollmentInvestmentObjectiveCategory.BUILD_WEALTH,
      experience: EnrollmentInvestmentExperienceCategory.A_LOT,
      taxFilingStatus: EnrollmentTaxFilingStatusType.SINGLE,
      isPoliticallyExposedPerson: false,
      affiliatedPoliticalOrganizations: [],
      hasPoliticallyExposedImmediateFamilyMembers: false,
    },
    personalAnnualGrossIncome: 123123,
    personalNetWorthRange: PersonalNetWorthRange.BETWEEN_200K_AND_500K,
    income: 123123,
    progress: 0.5,
  },
}

export const submitEnrollmentMultiConfirmInformationDataMock: EnrollmentMultiConfirmInformationSubmitOutput = {
  __typename: 'SubmitEnrollmentSuccess',
  path: '/enrollment/multi/disclosures',
}

export const mockGetEnrollmentMultiConfirmInformationData = graphql.mutation(
  'getEnrollmentMultiConfirmInformationData',
  () => {
    return HttpResponse.json({ data: { submitEnrollment: getEnrollmentMultiConfirmInformationDataMock } })
  },
)

export const mockSubmitEnrollmentMultiConfirmInformationData = graphql.mutation(
  'submitEnrollmentMultiConfirmInformationData',
  () => {
    return HttpResponse.json({ data: { submitEnrollment: submitEnrollmentMultiConfirmInformationDataMock } })
  },
)

export const mockEnrollmentMultiConfirmInformation = [
  mockGetEnrollmentMultiConfirmInformationData,
  mockSubmitEnrollmentMultiConfirmInformationData,
]
